import {birdsData} from "./birds-data.js";

let birdsObjectsIndex,
    sumOfBirdsObjects = 0;

for (let i = 0; i < birdsData.length; i++) {
  sumOfBirdsObjects += birdsData[i].length;
}

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

birdsObjectsIndex = getRandomIntInclusive(0, sumOfBirdsObjects - 1)

export {birdsObjectsIndex, getRandomIntInclusive};